<ng-container [formGroup]="form">

  <card-section>
    <span header-title>
      {{'cards.lexi_market_settings.order_delivery_settings.title' | translate }}
    </span>
    <span header-actions>
      <lxm-button type="beige" icon="save" label="action.save" [loading]="actionLoading.save"
        (click)="save()"></lxm-button>
    </span>
    <div body class="row">
      <info-array
      class="mt20 mb20"
      prelude="cards.lexi_market_settings.order_delivery_settings.info_text"
    ></info-array>
      <div class="col-8 no-padding">
        <ng-container [formGroup]="dayOfWeekFg" *ngFor="let dayOfWeekFg of activeDeliveryDays.controls">
          <form-field [label]="dayOfWeekFg.get('name').value">
            <slide-toggle toggle for="isActive"></slide-toggle>
          </form-field>
        </ng-container>
      </div>
    </div>
  </card-section>

</ng-container>